// Installed once by the owner lifecycle; kept import-free to avoid voice cycles.
let hooks:
  | {
      start: () => Promise<boolean> | undefined;
      stop: () => Promise<void> | undefined;
      sleep: () => Promise<void> | undefined;
    }
  | undefined;
export function setVoiceWakeHooks(next: typeof hooks): void {
  hooks = next;
}
export function prepareManualVoiceStart(
  isCancelled?: () => boolean,
): Promise<boolean> | undefined {
  const handoff = hooks?.start();
  return handoff && isCancelled
    ? awaitWakeHandoff(handoff, isCancelled)
    : handoff;
}
export function handleManualVoiceStop(): Promise<void> | undefined {
  return hooks?.stop();
}

export function requestVoiceWakeSleep(): Promise<void> | undefined {
  return hooks?.sleep();
}

async function awaitWakeHandoff(
  handoff: Promise<boolean>,
  isCancelled: () => boolean,
): Promise<boolean> {
  const released = await handoff;
  if (isCancelled()) return false;
  if (!released) throw new Error("Could not release the wake microphone.");
  return true;
}
